import { render } from "./SearchContent.vue?vue&type=template&id=bd77b796"
import script from "./SearchContent.vue?vue&type=script&lang=js"
export * from "./SearchContent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__